import moment from 'moment';

export const grubhubOrderDaysBefore = 6;
export const grubhubCanOrderNow = (eventDate: moment.Moment) => {
  const earliestOrderFromDate = moment.utc().startOf('day').add(grubhubOrderDaysBefore, 'days');
  return eventDate.startOf('day').isSameOrBefore(earliestOrderFromDate);
};
